import * as React from 'react';
import { useQuery, QueryHookOptions } from '@apollo/react-hooks';

import { message } from 'antd';

import { GET_ORGANIZATIONS_QUERY } from '@frontend/app/queries';
import { GetOrganizationsQuery } from '@frontend/app/queries/types/GetOrganizationsQuery';

const { useEffect } = React;
type IOptions = QueryHookOptions<GetOrganizationsQuery>;

export function useGetOrganizations(options: IOptions = {}) {
  const {
    loading,
    data: { organizations = [] } = {},
    error,
    refetch,
  } = useQuery<GetOrganizationsQuery>(GET_ORGANIZATIONS_QUERY, options);

  useEffect(() => {
    if (error) {
      message.error(error.message);
    }
  }, [error]);

  return {
    loading,
    organizations,
    error,
    refetch,
  };
}
